import React from 'react';
import {motion} from 'framer-motion';

const TransitionSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            Wie wir das gemeinsam umsetzen
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Damit du die Vorteile in der Praxis auch wirklich nutzen kannst, arbeiten wir mit Lexware Office.
            Das System ist erprobt, stabil und für Selbstständige gut geeignet. Es ist eine Cloudlösung, wodurch du immer mit der aktuellsten Version arbeitest. Außerdem ist es "Made in Germany".
            <br /><br />
            Wichtig ist: Du musst das Programm nicht vorher kennen.
            Ich richte es mit dir gemeinsam so ein, dass es zu deinem Alltag passt und du es sicher bedienen kannst.
            Schritt für Schritt – verständlich erklärt.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TransitionSection;